import { ItemType } from '@vista-digital/ocapi-types/v1';
import { isNonEmptyArray } from '../../../../utils/array-utils';
import { getAvailableParentSalesOptions } from '../../utils/items/get-available-parent-sales-options';
import { isItemSupported } from '../../utils/items/is-item-supported';
import { isNormalItemAvailable } from '../../utils/items/item-price-utils';
import { getItemById } from './get-item-by-id';
/**
 * Determines whether or not a [[SellableItem]] is both supported and available for purchase.
 */
export const isSellableItemAvailable = (sellableItem) => {
    const item = getItemById(sellableItem.itemId);
    if (!item)
        throw new Error(`Cannot find item with ID: '${sellableItem.itemId}'.`);
    if (!isItemSupported(item))
        return false;
    switch (item.type) {
        case ItemType.Normal:
            return isNormalItemAvailable(item, sellableItem.prices);
        case ItemType.ParentSales:
            return isNonEmptyArray(getAvailableParentSalesOptions(item));
        default:
            return false;
    }
};
